import { render, staticRenderFns } from "./GraficaCursoDs.vue?vue&type=template&id=1371c258&"
import script from "./GraficaCursoDs.vue?vue&type=script&lang=js&"
export * from "./GraficaCursoDs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports